export var SelectionType;
(function (SelectionType) {
    SelectionType["ML"] = "ML";
    SelectionType["OU"] = "OU";
    SelectionType["HC"] = "HC";
    SelectionType["QA"] = "QA";
    SelectionType["MLET"] = "MLET";
    SelectionType["TGET"] = "TGET";
    SelectionType["TQ"] = "TQ";
    SelectionType["PW"] = "PW";
})(SelectionType || (SelectionType = {}));
//# sourceMappingURL=SelectionType.js.map